import React, { Fragment } from 'react';

const NativeAppFeatureListSchools = () => {
  return (
    <Fragment>
      <li>
        Share your student&apos;s matched photo stream with family and friends.
      </li>
      <li>Post &amp; download your favorite pics in hi-res.</li>
      <li>Create and send Waldograms featuring your photos.</li>
      <li>Order prints delivered directly to your home.</li>
    </Fragment>
  );
};

export default NativeAppFeatureListSchools;
